// Module toggles. Reuses the canonical MODULE_CATALOG from
// @erp/data-access/interfaces so the Builder shows the same set as the
// onboarding wizard and the sidebar.

import { useTranslation } from 'react-i18next';
import { Card, CardContent } from '@erp/ui';
import { MODULE_CATALOG, ALWAYS_ON_MODULES } from '@erp/data-access/interfaces';
import type { ModulesFlags } from '@erp/app-builder';

interface ModulesTabProps {
  value: ModulesFlags;
  onChange: (next: ModulesFlags) => void;
}

export function ModulesTab({ value, onChange }: ModulesTabProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-3 max-w-2xl">
      <p className="text-sm text-muted-foreground">
        {t('appBuilder.modules.help', {
          defaultValue: 'Activez les modules visibles sur l’app mobile. Les modules désactivés masquent automatiquement leurs écrans.',
        })}
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
        {MODULE_CATALOG.map((m) => {
          const isAlwaysOn = ALWAYS_ON_MODULES.includes(m.key);
          const checked = (value as Record<string, boolean>)[m.key] === true || isAlwaysOn;
          return (
            <Card key={m.key} className={checked ? 'border-primary' : ''}>
              <CardContent className="py-3 flex items-center justify-between gap-3">
                <div>
                  <div className="font-medium text-sm">
                    {t(`onboarding.modules.${m.i18nKey}.title`, { defaultValue: m.key })}
                  </div>
                  <div className="text-xs text-muted-foreground mt-0.5">
                    {t(`onboarding.modules.${m.i18nKey}.desc`, { defaultValue: '' })}
                  </div>
                </div>
                <input
                  type="checkbox"
                  className="h-5 w-5"
                  checked={checked}
                  disabled={isAlwaysOn}
                  onChange={(e) => onChange({ ...value, [m.key]: e.target.checked })}
                />
              </CardContent>
            </Card>
          );
        })}
      </div>
    </div>
  );
}
